import React from 'react';

// Full-page status card for fallback states (errors, completion notices),
// styled to match the main survey card: brand header bar, Freese logo.
export default function StatusPage(props) {
    return (
        <div className='container mt-4' style={{maxWidth:'640px'}}>
            <div className='card shadow'>
                <div className='row g-0 pt-3 pb-3 align-items-center' style={{backgroundColor:'#e3f1f3'}}>
                    <div className='col-4 ps-3'>
                        <img src='https://www.freese.com/wp-content/uploads/2020/09/logo-dark.svg' className='img-fluid rounded' alt='Freese and Nichols'/>
                    </div>
                    <div className='col-8 h5 text-center mb-0 pe-3'>
                        Project Satisfaction Survey
                    </div>
                </div>
                <div className='card-body text-center p-4'>
                    <i className={'bi ' + props.icon + ' display-4'} style={{color: props.iconColor || '#015d91'}}></i>
                    <div className='h3 mt-2'>{props.title}</div>
                    <p className='mb-1'>{props.message}</p>
                    {props.detail && <p className='text-muted small mb-0 mt-2'>{props.detail}</p>}
                </div>
            </div>
        </div>
    );
}
